import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdProductAssignmentApi, ProductAssignmentResult } from '../tokens/ed-product-assignment.token';

/**
 * REST implementation of the E-D Product Assignment API (PRD §3.10, EM-838).
 *
 *   POST /services/embedded/api/v1/ed/sme/{id}/products   (422 when the product is not onboarded)
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_PRODUCT_ASSIGNMENT.
 */
@Injectable({ providedIn: 'root' })
export class EdProductAssignmentRestService implements EdProductAssignmentApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/sme`;

  assignProduct(smeApplicationId: number, product: string): Observable<ProductAssignmentResult> {
    return this.http.post<ProductAssignmentResult>(`${this.base}/${smeApplicationId}/products`, { product });
  }
}
